"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

const getOrder = ['organizationId', 'orderNo', 'siteId', 'locale'];
const getPaymentMethodsForOrder = ['organizationId', 'orderNo', 'siteId', 'locale'];
const getTaxesFromOrder = ['organizationId', 'orderNo', 'siteId'];
var _default = exports.default = {
  getOrder,
  getPaymentMethodsForOrder,
  getTaxesFromOrder
};